
export default {
	state: {
		user: ""
	},
	mutations: {
		updateUsers(state, obj) {
			state.user = obj
		}
	},
	getters: {

	},
	actions: {

	}
}


// WEBPACK FOOTER //
// ./src/components/author/index.js